import DefaultDetail from './default.js'

export {
  DefaultDetail,
}
